import { z } from 'zod';

export const contactSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  email: z.string().email('Enter a valid email'),
  subject: z.string().optional(),
  message: z.string().min(5, 'Message is required'),
});

export const quoteSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  email: z.string().email('Enter a valid email'),
  company: z.string().optional(),
  country: z.string().optional(),
  category: z.string().optional(),
  message: z.string().min(5, 'Message is required'),
  enquiry_type: z.string(),
  quantity: z.string(),
  incoterm: z.string(),
  destination_port: z.string().optional(),
});

export const rfqSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  email: z.string().email('Enter a valid email'),
  company: z.string().optional(),
  country: z.string().optional(),
  phone: z.string().optional(),
  category: z.string().optional(),
  product_slug: z.string().optional(),
  enquiry_type: z.string(),
  quantity: z.string().min(1, 'Quantity is required'),
  target_price: z.string().optional(),
  incoterm: z.string(),
  destination_port: z.string().optional(),
  message: z.string().min(5, 'Message is required'),
});

export const checkoutCustomerSchema = z.object({
  name: z.string().min(2, 'Name is required'),
  email: z.string().email('Enter a valid email'),
  company: z.string().optional(),
  country: z.string().optional(),
});